import { HttpStatusCodes } from "@/constants/httpStatusCodes";

export type ServerFileError = {
  error: string;
  errorTooltip?: string;
};

export type ServerFileErrorsByName = Record<string, ServerFileError>;

type FilenameValidationErrorData = {
  file_error?: string;
  filename?: string[];
  message?: string;
};

function getAxiosErrorStatus(error: unknown): number | undefined {
  return (error as { response?: { status?: number } })?.response?.status;
}

function getAxiosErrorData(error: unknown): FilenameValidationErrorData | undefined {
  return (error as { response?: { data?: FilenameValidationErrorData } })?.response?.data;
}

export function isDocumentFilenameValidationError(error: unknown): boolean {
  const data = getAxiosErrorData(error);

  if (!data || getAxiosErrorStatus(error) !== HttpStatusCodes.BAD_REQUEST) return false;

  return (
    Array.isArray(data.filename) && data.filename.length > 0 && typeof data.file_error === "string"
  );
}

export function getServerFileErrorsFromUploadError(error: unknown): ServerFileErrorsByName | null {
  const data = getAxiosErrorData(error);

  if (!data || !isDocumentFilenameValidationError(error)) return null;

  const message = data.message || "Invalid filename";
  const tooltip = data.file_error || message;

  const filenames = data.filename;

  if (!filenames?.length) return null;

  return filenames.reduce<ServerFileErrorsByName>((acc, name) => {
    acc[name] = { error: message, errorTooltip: tooltip };
    return acc;
  }, {});
}
